var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1690961018889,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5973,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.573333 210.304a32 32 0 0 1 0 45.226667 362.666667 362.666667 0 0 0 0 512.896 32 32 0 0 1-45.269333 45.269333c-166.613333-166.613333-166.613333-436.778667 0-603.392a32 32 0 0 1 45.226667 0z m558.122667 0c166.613333 166.613333 166.613333 436.778667 0 603.392a32 32 0 0 1-45.226667-45.226667 362.666667 362.666667 0 0 0 0-512.896 32 32 0 1 1 45.226667-45.269333zM376.234667 330.965333a32 32 0 0 1 0 45.269334 192 192 0 0 0 0 271.530666 32 32 0 0 1-45.226667 45.226667 256 256 0 0 1 0-362.026667 32 32 0 0 1 45.226667 0z m316.8 0a256 256 0 0 1 0 362.069334 32 32 0 1 1-45.269334-45.269334 192 192 0 0 0 0-271.530666 32 32 0 0 1 45.226667-45.226667zM512 448a64 64 0 1 1 0 128 64 64 0 0 1 0-128z",
    "p-id": 5974
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLive);
export default __webpack_public_path__ + "static/media/icon-live.f5c189d95e93581d935f3c4d69eec796.svg";
export { ForwardRef as ReactComponent };